import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import CircularHighlightedIcon from 'components/circular-highlighted-icon'
import CreditCardOutlinedIcon from 'components/material-symbol/icons/CreditCard'
import StripeAccountSetupRedirect from './stripe-account-setup-redirect'
import { amplitudeEvent } from 'lib/amplitude'
import { paymentAccountEmptyStateIconProps } from './styles'

const useStyles = makeStyles(theme => ({
  helperText: {
    fontSize: '0.875rem',
    lineHeight: 1.5,
    marginBottom: theme.spacing(4),
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
  },
}))

const AddPaymentAccountForm = ({ onCancel }) => {
  const classes = useStyles()
  const [formSubmission, setFormSubmission] = useState(null)
  const { register, handleSubmit, errors } = useForm()
  const onSubmit = async formValues => {
    amplitudeEvent('began-payment-account-onboarding', {
      payment_account_name: formValues.paymentAccountName,
      source: 'Coach',
      url: window.location.href,
      path: window.location.pathname,
    })
    setFormSubmission(formValues)
  }

  if (formSubmission) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        p={4}
      >
        <Box mb={2}>
          <CircularHighlightedIcon
            icon={CreditCardOutlinedIcon}
            {...paymentAccountEmptyStateIconProps}
          />
        </Box>
        <Box mb={2}>
          <Typography variant="h6">Sending you to Stripe...</Typography>
        </Box>
        <Box textAlign="center">
          <Typography variant="body1" color="textSecondary">
            We’re sending you to Stripe, where you can setup an online payment
            account.
          </Typography>
        </Box>
        <StripeAccountSetupRedirect
          accountName={formSubmission.paymentAccountName}
        />
      </Box>
    )
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Typography
        variant="body1"
        color="textSecondary"
        className={classes.helperText}
      >
        Use a name that will help you identify the connected bank account at a
        glance.
      </Typography>
      <Box mb={3}>
        <TextField
          autoFocus
          id="paymentAccountName"
          name="paymentAccountName"
          label="Online payment account name"
          inputRef={register({ required: true, minLength: 1 })}
          variant="outlined"
          fullWidth
          error={!!errors.paymentAccountName}
          helperText={errors?.paymentAccountName && 'This field is required'}
        />
      </Box>
      <Box className={classes.actions}>
        <Button type="button" variant="text" size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" color="primary" size="large">
          Next
        </Button>
      </Box>
    </form>
  )
}

export default AddPaymentAccountForm
